import React from "react";
import { Resident } from "@commr/admin/models/user/resident/resident";
import ResidentDataContainer from "../../components/residents/residentDataContainer";

const AddResidentPage: React.FC<React.PropsWithChildren<unknown>> = () => (
  <ResidentDataContainer resident={new Resident()} />
);

export default AddResidentPage;
